import React from 'react';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/react-hooks';
import { useIntl } from 'react-intl';
import { ADD_ABILITY } from './mutations';
import { growlActionSuccess } from '../../../utils/NotificationUtil';
import { withGrowl } from '../../../components/GrowlNotifications';
import { growlShape } from '../../../components/prop-types';
import messages from './intl-messages';


const ActivateAbility = ({
  sourceAccountId, targetAccountId, competence, ability, growl, fetchData,
}) => {
  const [addAbility] = useMutation(ADD_ABILITY);
  const intl = useIntl();

  return (
    <>
      <Button
        type="button"
        className="p-button-secondary"
        icon="pi pi-lock-open"
        label={intl.formatMessage(messages.add)}
        onClick={async () => {
          await addAbility({
            variables: {
              input: {
                sourceAccountId,
                targetAccountId,
                competence,
                ability,
              },
            },
          })
            .then(() => {
              growlActionSuccess(growl, intl.formatMessage(messages.addAbilitySuccess));
              fetchData();
            })
            .catch(() => {
              growl.show({ severity: 'error', detail: intl.formatMessage(messages.addAbilityError), sticky: true });
            });
        }}
      />
    </>
  );
};

ActivateAbility.propTypes = {
  sourceAccountId: PropTypes.number.isRequired,
  targetAccountId: PropTypes.number.isRequired,
  competence: PropTypes.string.isRequired,
  ability: PropTypes.string.isRequired,
  growl: growlShape.isRequired,
  fetchData: PropTypes.func.isRequired,
};

export default withGrowl(ActivateAbility);
